var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "picture-vote" },
    [
      _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mul-options" },
        _vm._l(_vm.options, function (item, index) {
          return _c(
            "div",
            {
              key: item.id,
              class: [
                "option",
                _vm.isThreeOption && "option-three",
                _vm.isTwoOption && "option-two",
              ],
              on: {
                click: function ($event) {
                  _vm.goToVote(item)
                },
              },
            },
            [
              _c("div", { staticClass: "img-c" }, [
                _c("img", { attrs: { src: item.optionUrl } }),
              ]),
              _vm._v(" "),
              !_vm.isVoted && !_vm.isFinish
                ? _c(
                    "div",
                    {
                      staticClass: "mul-option-status-1",
                      style: _vm.getOptionStatus1Stype(index),
                    },
                    [_vm._v(_vm._s(item.name))]
                  )
                : [
                    _c(
                      "div",
                      {
                        staticClass: "mul-option-status-2",
                        style: _vm.getOptionStatus2Stype(item, index),
                      },
                      [
                        _c(
                          "div",
                          { class: ["name", _vm.isTwoOption && "options-two"] },
                          [
                            _c("div", { staticClass: "left" }, [
                              _c("span", { staticClass: "text" }, [
                                _vm._v(_vm._s(item.name)),
                              ]),
                              _vm._v(" "),
                              _vm.userOptionId == item.id
                                ? _c("img", {
                                    staticClass: "selected-icon",
                                    attrs: {
                                      src: _vm.getOptionSelectIcon(index),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  class: [
                                    "percent",
                                    _vm.isTwoOption && "two-option-percent",
                                  ],
                                },
                                [_vm._v(_vm._s(item.percent) + "%")]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "percent-bar" }),
                      ]
                    ),
                  ],
            ],
            2
          )
        })
      ),
      _vm._v(" "),
      _c("Tips", { attrs: { fields: _vm.fields, isFinish: _vm.isFinish } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }